import { createElement } from 'react';
import { ItemTypes } from '../Constants';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';
import { store, ScreenComponentProps, ComponentDesc, ShelfComponentProps } from '../store';
import { observer } from 'mobx-react';
import withStyles from 'react-jss';
import HeightWidthEditor from './common/HeightWidthEditor';
import MarginEditor from './common/MarginEditor';
import PaddingEditor from './common/PaddingEditor';
import BorderEdit from './common/BorderEdit';
import BorderRadius from './common/BorderRadius';
import ColorPicker from './common/ColorPicker';
import BackgroundColorPicker from './common/BackgroundColorPicker';
import Typograph from './common/Typograph';

import { settingsComponentStyles, shelfComponentStyles } from './common/styles';
import { flowRight } from 'lodash';

const svg = require('./icons/horizontal.svg');
//const menu_button = require('./icons/menu_button.svg');

interface DividerSettings {
    text: string;
}

let defaultTemplate = {
    type: 'DIVIDER',
    style: {
        border: '10px solid black',
    },
    settings: {
        text: '',
    },
    name: 'Divider',
};

let shelfComponent = flowRight([
    withStyles(shelfComponentStyles),
    DragSource(
        ItemTypes.COMPONENT,
        {
            beginDrag(props, monitor, component): ComponentDesc<DividerSettings> {
                let t = JSON.parse(JSON.stringify(defaultTemplate));
                t.id = +new Date();
                return t;
            },
        },
        (connect: DragSourceConnector, monitor: DragSourceMonitor) => {
            return {
                connectDragSource: connect.dragSource(),
                isDragging: monitor.isDragging(),
            };
        }
    ),
])((props: ShelfComponentProps<typeof shelfComponentStyles>) => {
    let { connectDragSource, isDragging, classes } = props;
    return connectDragSource(
        <div className={classes.outer}>
            <div className={classes.section}>
                <img src={svg} className={classes.icon} />
                <span className={classes.label}>Divider</span>
            </div>
        </div>
    );
});

function ScreenComponent({ connectDragSource, isDragging, descriptor }: ScreenComponentProps<DividerSettings>) {
    return (
        <div
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: 'move',
                // minHeight: '5px',
            }}
            onClick={(e) => store.selectComponent(descriptor)}>
            <hr />
        </div>
    );
}

/**
 * Define the settings panel for this component
 * @type {({ descriptor }: any) => any}
 */

const SettingsComponent = flowRight([withStyles(settingsComponentStyles), observer])(({ descriptor, classes }: any) => {
    return (
        <div>
            <div className={classes.root} />
            <div>
                <Typograph descriptor={descriptor} />
                <HeightWidthEditor descriptor={descriptor} />
                <MarginEditor descriptor={descriptor} />
                <PaddingEditor descriptor={descriptor} />
                <BorderEdit descriptor={descriptor} />
                <BorderRadius descriptor={descriptor} />
                <BackgroundColorPicker descriptor={descriptor} />
                <ColorPicker descriptor={descriptor} />
            </div>
        </div>
    );
});

store.registerComponent({
    name: 'DIVIDER',
    type: 'component',
    shelfComponent: shelfComponent,
    screenComponent: observer(ScreenComponent),
    settingsComponent: SettingsComponent,
    defaultTemplate,
    svg,
});

//export default component;
